/// <amd-module name="SuiteCommerce.InventoryDisplay.Common.InstrumentationHelper"/>
define("SuiteCommerce.InventoryDisplay.Common.InstrumentationHelper", ["require", "exports", "SuiteCommerce.InventoryDisplay.Instrumentation"], function (require, exports, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.InstrumentationHelper = void 0;
    var QueueNameSuffix = '-InventoryDisplay`';
    var ExtensionVersion = '1.2.10';
    var ComponentArea = 'SC Inventory Display';
    var InstrumentationHelper = /** @class */ (function () {
        function InstrumentationHelper() {
        }
        InstrumentationHelper.initializeInstrumentation = function (environment) {
            Instrumentation_1.default.initialize({
                environment: environment,
                queueNameSuffix: QueueNameSuffix,
                defaultParameters: {
                    componentArea: ComponentArea,
                    extensionVersion: ExtensionVersion,
                },
            });
        };
        return InstrumentationHelper;
    }());
    exports.InstrumentationHelper = InstrumentationHelper;
});
